// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"f8c29022","551":"f9dce936"}[chunkId] + ".chunk.js";
};